import React from "react";
import { Slider } from "rsuite";

const SliderDefLevel = ({ handleChange, value, className }) => {
  return (
    <div className={className}>
      <Slider
        style={{ height: 200, borderRadius: "0px", background: "#f2f2f5", width: "9px" }}
        vertical
        progress
        value={value}
        max={100}
      />
    </div>
  );
};

export default SliderDefLevel;
